import { Theme } from '@mui/material';

import { ComponentStyles } from '../types';
import { tokens } from './generated/tokens';
import { DsShadow } from './shadows';

export const focusProps = (): ComponentStyles => ({
  outline: `2px solid ${tokens.theme.border.focus}`,
  // TODO (Justas): shadow should come from tokens
  boxShadow: `0px 0px 4px ${tokens.theme.border.focus}`,
});

export const boxShadowBorder = (token: string): string =>
  `inset 0 0 0 1px ${token}`;

export const activeProps = (theme: Theme): ComponentStyles => ({
  border: `1px solid ${tokens.theme.border.selection.primary}`,
  boxShadow: theme.shadows[DsShadow.ACTIVE_GLOW],
});

export const AbsolutePseudo: ComponentStyles = {
  content: '""',
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
};
